<template>
    <nav class="social-links">
        <h4 class="social-links__title">Share this {{ type }}</h4>

        <div class="social-links__links">
            <ClientOnly>
                <LinkedinShareButton>
                    <BaseIcon
                        icon="linkedin"
                        class="social-links__icon dn-icon--square"
                        :auto-color="false"
                        title="Share on LinkedIn"
                    />
                </LinkedinShareButton>

                <FacebookShareButton>
                    <BaseIcon
                        icon="facebook"
                        class="social-links__icon dn-icon--square"
                        :auto-color="false"
                        title="Share on Facebook"
                    />
                </FacebookShareButton>

                <TwitterShareButton>
                    <BaseIcon
                        icon="twitter"
                        class="social-links__icon dn-icon--square"
                        :auto-color="false"
                        title="Share on X"
                    />
                </TwitterShareButton>

                <WhatsappShareButton>
                    <BaseIcon
                        icon="whatsapp"
                        class="social-links__icon dn-icon--square"
                        :auto-color="false"
                        title="Send on WhatsApp"
                    />
                </WhatsappShareButton>
            </ClientOnly>

            <BaseIcon
                title="Copy link to clipboard"
                :icon="linkCopied ? 'check' : 'link'"
                class="social-links__icon dn-icon--square"
                :auto-color="false"
                @click="copy"
            />
        </div>
    </nav>
</template>

<script setup>
import {
    FacebookShareButton,
    LinkedinShareButton,
    TwitterShareButton,
    WhatsappShareButton,
} from '@digitalnatives/share-button';


const props = defineProps({
    type: {
        type: String,
        default: 'page'
    }
});

const type = computed(() => props.type);

const { copyToClipboard, linkCopied } = useClipboard();

const copy = async() => {
    await copyToClipboard(window.location.href);
};

</script>

<style lang="less">
.social-links__title {
    .typography-label-secondary;
    margin-bottom: .75rem;
}

.social-links__links {
    display: flex;
    align-items: center;

    .dn-share-button {
        line-height: 0;
        padding: 0;
    }

    & > * + * {
        margin: 0 0 0 1rem;
    }

    @media @q-lg-min {
        & > * + * {
            margin: 0 0 0 1.5rem;
        }
    }
}

.social-links__icon.dn-icon {
    flex: 0 0 auto;
    cursor: pointer;
    line-height: 0;
    font-size: 1.25rem;

    @media @q-lg-min {
        font-size: 1.6875rem;
    }
}
</style>
